import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-myob-customers-grid-brand',
  templateUrl: './myob-customers-grid-brand.component.html',
  styleUrls: ['./myob-customers-grid-brand.component.scss']
})
export class MyobCustomersGridBrandComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
